// Centralized dayjs plugin + locale setup.
//
// dayjs.extend() mutates the global dayjs singleton, so a plugin only needs to
// be registered once — but it MUST run before any component calls the plugin
// method. Historically each module did its own dayjs.extend(...), which worked
// only because those modules happened to be evaluated (in the eager bundle)
// before anything rendered. Once routes/utilities got code-split into lazy
// chunks, the evaluation order stopped being guaranteed: a shared component
// could render and call e.g. `.isSameOrAfter(...)` before the lazy chunk that
// extended that plugin had loaded — throwing "isSameOrAfter is not a function".
//
// Importing this module first in the entry (index.tsx) registers every plugin
// the app uses at boot, eliminating that ordering hazard. The per-module
// dayjs.extend calls remain (harmless + idempotent) but no longer load-bearing.
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);
dayjs.extend(quarterOfYear);

dayjs.locale('es');

export default dayjs;
